import { environment } from "../../../environments/environment";

export const emailNotificationTemplateEN = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Aims Notification</title>
    <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap" rel="stylesheet">
    <style>
        /* Base Styles */
        body {
            margin: 0;
            padding: 0;
            width: 100% !important;
            -webkit-text-size-adjust: 100%;
            -ms-text-size-adjust: 100%;
            background-color: #f1f5f9;
            font-family: 'Inter', Helvetica, Arial, sans-serif;
        }

        .email-background {
            background-color: #f1f5f9;
        }

        table {
            border-spacing: 0;
            border-collapse: collapse;
            table-layout: fixed;
            margin: 0 auto;
        }

        img {
            border: 0;
            line-height: 100%;
            outline: none;
            text-decoration: none;
            display: block;
        }

        .content-table {
            width: 100%;
            max-width: 600px;
        }

        .main-container {
            background-color: #ffffff;
            border-radius: 8px;
            border: 1px solid #e2e8f0;
            overflow: hidden;
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        }

        /* Typography & Components */
        .header {
            background-color: #00569c;
            padding: 40px 30px;
            text-align: center;
        }

        .logo-container {
            padding-bottom: 15px;
        }

        .logo-img {
            margin: 0 auto;
            max-width: 200px;
            height: auto;
            display: block;
        }

        .header h1 {
            color: #ffffff;
            margin: 0;
            font-size: 16px;
            font-weight: 600;
            letter-spacing: 1.5px;
            text-transform: uppercase;
            opacity: 0.9;
        }

        .body-content {
            padding: 40px 30px;
            color: #334155;
            line-height: 1.6;
        }

        .notification-badge {
            display: inline-block;
            padding: 4px 12px;
            border-radius: 9999px;
            font-size: 11px;
            font-weight: 700;
            text-transform: uppercase;
            margin-bottom: 16px;
            letter-spacing: 0.5px;
        }

        /* Notification Type Variants */
        .badge-primary {
            background-color: #00569c;
            color: #ffffff;
        }

        .badge-success {
            background-color: #dcfce7;
            color: #166534;
        }

        .badge-error {
            background-color: #fee2e2;
            color: #ef4444;
        }

        .headline {
            font-size: 22px;
            font-weight: 700;
            color: #00569c;
            margin: 0 0 16px 0;
        }

        .details-box {
            background-color: #f8fafc;
            border-left: 4px solid #00569c;
            padding: 20px;
            margin: 25px 0;
            border-radius: 0 4px 4px 0;
        }

        .details-row {
            margin-bottom: 10px;
            font-size: 14px;
        }

        .details-label {
            font-weight: 600;
            color: #64748b;
            width: 140px;
            display: inline-block;
            vertical-align: top;
        }

        .details-value {
            display: inline-flex;
            gap: 8px;
            color: #1e293b;
            font-weight: 500;
            width: 380px; /* Adjusted for desktop */
        }

        .details-value span{
            font-weight: 600;
        }

        .btn {
            background-color: #00569c;
            color: #ffffff !important;
            padding: 14px 32px;
            text-decoration: none;
            border-radius: 6px;
            font-weight: 600;
            display: inline-block;
            margin-top: 10px;
        }

        .footer {
            padding: 30px;
            text-align: center;
            font-size: 12px;
            color: #62829f;
        }

        /* Responsive */
        @media screen and (max-width: 600px) {
            .content-table {
                width: 95% !important;
            }

            .body-content {
                padding: 30px 20px;
            }

            .details-label {
                width: 100%;
                display: block;
                margin-bottom: 2px;
            }

            .details-value {
                width: 100%;
                display: block;
                margin-bottom: 10px;
                display : inline-flex;
                gap: 8px;

            }
        }
    </style>
</head>
<body>
    <center class="email-background">
        <table role="presentation" class="content-table" align="center">
            <tr>
                <td style="padding: 20px 0;">
                    <!-- Main Card -->
                    <table role="presentation" width="100%" class="main-container">
                        <!-- Header -->
                        <tr>
                            <td class="header">
                                <table role="presentation" width="100%">
                                    <tr>
                                        <td align="center" class="logo-container">
                                           <img class="logo-img" src="{{logoUrl}}" alt="AIMS Logo">
                                            
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>

                        <!-- Content -->
                        <tr>
                            <td class="body-content">
                                <!-- Type Badge (badge-primary, badge-success, or badge-error) -->
                                <div class="notification-badge badge-primary">System Notification</div>

                                <h2 class="headline">Notification Summary</h2>

                                <p>Hello,</p>
                                <p>An update has been made in the portal that requires your attention. Please find the details below:</p>

                                <!-- Generic Details Section -->
                                <div class="details-box">
                                    <div class="details-row">
                                        <span class="details-label">Type:</span><br>
                                        <p class="details-value">{{notificationType}}</p>
                                    </div>
                                    <div class="details-row">
                                        <span class="details-label">Description:</span><br>
                                        <p class="details-value" style="color: #00569c; white-space: normal; word-break: break-word;">{{description}}</p>
                                    </div>                                 
                                    <div class="details-row">
                                        <span class="details-label">Date:</span><br>
                                        <p class="details-value" style="color: #ef4444;">{{date}}</p>
                                    </div>
                                </div>

                                <p>{{ctaText}}</p>

                                <table role="presentation" cellspacing="0" cellpadding="0" align="center">
                                    <tr>
                                        <td align="center" style="padding-top: 10px;">
                                            <a href="{{redirectUrl}}" class="btn">Open Portal</a>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>

                    <!-- Footer -->
                    <table role="presentation" width="100%">
                        <tr>
                            <td class="footer">
                                <p>&copy; © 2026 AIMS. All rights reserved.</p>
                                <p>This is an automatically generated message. Please do not reply to this email.</p>
                                <p style="margin-top: 10px;">
                                    <a href="#" style="color: #00569c; text-decoration: underline;">Account Settings</a> |
                                    <a href="#" style="color: #00569c; text-decoration: underline;">Support Center</a>
                                </p>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
    </center>
</body>
</html>`;

export const emailNotificationTemplateDE = `<!DOCTYPE html>
<html lang="de">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>AIMS Benachrichtigung</title>
    <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap" rel="stylesheet">
    <style>
        /* Base Styles */
        body {
            margin: 0;
            padding: 0;
            width: 100% !important;
            -webkit-text-size-adjust: 100%;
            -ms-text-size-adjust: 100%;
            background-color: #f1f5f9;
            font-family: 'Inter', Helvetica, Arial, sans-serif;
        }

        .email-background {
            background-color: #f1f5f9;
        }

        table {
            border-spacing: 0;
            border-collapse: collapse;
            table-layout: fixed;
            margin: 0 auto;
        }

        img {
            border: 0;
            line-height: 100%;
            outline: none;
            text-decoration: none;
            display: block;
        }

        .content-table {
            width: 100%;
            max-width: 600px;
        }

        .main-container {
            background-color: #ffffff;
            border-radius: 8px;
            border: 1px solid #e2e8f0;
            overflow: hidden;
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        }

        .header {
            background-color: #00569c;
            padding: 40px 30px;
            text-align: center;
        }

        .logo-container {
            padding-bottom: 15px;
        }

        .logo-img {
            margin: 0 auto;
            max-width: 200px;
            height: auto;
            display: block;
        }

        .header h1 {
            color: #ffffff;
            margin: 0;
            font-size: 16px;
            font-weight: 600;
            letter-spacing: 1.5px;
            text-transform: uppercase;
            opacity: 0.9;
        }

        .body-content {
            padding: 40px 30px;
            color: #334155;
            line-height: 1.6;
        }

        .notification-badge {
            display: inline-block;
            padding: 4px 12px;
            border-radius: 9999px;
            font-size: 11px;
            font-weight: 700;
            text-transform: uppercase;
            margin-bottom: 16px;
            letter-spacing: 0.5px;
        }

        .badge-primary {
            background-color: #00569c;
            color: #ffffff;
        }

        .badge-success {
            background-color: #dcfce7;
            color: #166534;
        }

        .badge-error {
            background-color: #fee2e2;
            color: #ef4444;
        }

        .headline {
            font-size: 22px;
            font-weight: 700;
            color: #00569c;
            margin: 0 0 16px 0;
        }

        .details-box {
            background-color: #f8fafc;
            border-left: 4px solid #00569c;
            padding: 20px;
            margin: 25px 0;
            border-radius: 0 4px 4px 0;
        }

        .details-row {
            margin-bottom: 10px;
            font-size: 14px;
        }

        .details-label {
            font-weight: 600;
            color: #64748b;
            width: 140px;
            display: inline-block;
            vertical-align: top;
        }

        .details-value {
            display: inline-flex;
            gap: 8px;
            color: #1e293b;
            font-weight: 500;
            width: 380px;
        }

        .details-value span{
            font-weight: 600;
        }

        .btn {
            background-color: #00569c;
            color: #ffffff !important;
            padding: 14px 32px;
            text-decoration: none;
            border-radius: 6px;
            font-weight: 600;
            display: inline-block;
            margin-top: 10px;
        }

        .footer {
            padding: 30px;
            text-align: center;
            font-size: 12px;
            color: #62829f;
        }

        @media screen and (max-width: 600px) {
            .content-table {
                width: 95% !important;
            }

            .body-content {
                padding: 30px 20px;
            }

            .details-label {
                width: 100%;
                display: block;
                margin-bottom: 2px;
            }

            .details-value {
                width: 100%;
                display: block;
                margin-bottom: 10px;
                display : inline-flex;
                gap: 8px;
            }
        }
    </style>
</head>
<body>
    <center class="email-background">
        <table role="presentation" class="content-table" align="center">
            <tr>
                <td style="padding: 20px 0;">
                    <table role="presentation" width="100%" class="main-container">
                        <tr>
                            <td class="header">
                                <table role="presentation" width="100%">
                                    <tr>
                                        <td align="center" class="logo-container">
                                           <img class="logo-img" src="{{logoUrl}}" alt="AIMS Logo">
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>

                        <tr>
                            <td class="body-content">
                                <div class="notification-badge badge-primary">Systembenachrichtigung</div>

                                <h2 class="headline">Benachrichtigungsübersicht</h2>

                                <p>Hallo,</p>
                                <p>Im Portal wurde eine Aktualisierung vorgenommen, die Ihre Aufmerksamkeit erfordert. Bitte finden Sie die Details unten:</p>

                                <div class="details-box">
                                    <div class="details-row">
                                        <span class="details-label">Typ:</span><br>
                                        <p class="details-value">{{notificationType}}</p>
                                    </div>
                                    <div class="details-row">
                                        <span class="details-label">Beschreibung:</span><br>
                                        <p class="details-value" style="color: #00569c; white-space: normal; word-break: break-word;">{{description}}</p>
                                    </div>                                 
                                    <div class="details-row">
                                        <span class="details-label">Datum:</span><br>
                                        <p class="details-value" style="color: #ef4444;">{{date}}</p>
                                    </div>
                                </div>

                                <p>{{ctaText}}</p>

                                <table role="presentation" cellspacing="0" cellpadding="0" align="center">
                                    <tr>
                                        <td align="center" style="padding-top: 10px;">
                                            <a href="{{redirectUrl}}" class="btn">Portal öffnen</a>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>

                    <table role="presentation" width="100%">
                        <tr>
                            <td class="footer">
                                <p>&copy; © 2026 AIMS. Alle Rechte vorbehalten.</p>
                                <p>Dies ist eine automatisch generierte Nachricht. Bitte antworten Sie nicht auf diese E-Mail.</p>
                                <p style="margin-top: 10px;">
                                    <a href="#" style="color: #00569c; text-decoration: underline;">Kontoeinstellungen</a> |
                                    <a href="#" style="color: #00569c; text-decoration: underline;">Support-Center</a>
                                </p>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
    </center>
</body>
</html>`;
